export class ModuleHelper {
    static getTotalPagesByModule(modules) {
        return modules?.reduce((acc, module) => ({ ...acc, [module.id]: module.totalPages }), {}) ?? {};
    }
    static getModuleType(module) {
        if (module.paidModule)
            return 'PAID';
        if (module.extra)
            return 'EXTRA';
        return 'MAIN';
    }
}
